<template>
<div class="chapter">
<div class="inner_page">
<div id="Maps">
<p class="fm-title"><a id="page_ix">List of Maps</a></p><a id="page_ix">
</a><p class="noindent"><a id="page_ix"></a><span href="#/xhtml/10_Chapter02_1#fig2_1" title="Link target outside of Sample">Disposition of German Panzer-Division and Soviet Tank/Mechanized Corps on 1 January 1943</span></p>
<p class="noindent"><span href="#/xhtml/10_Chapter02_1#fig2_2" title="Link target outside of Sample">LVII Panzerkorps stand north of the Manych River, 5–11 January 1943</span></p>
<p class="noindent"><span href="#/xhtml/10_Chapter02_1#fig2_3" title="Link target outside of Sample">The Ostrogozhsk-Rossosh Operation, 13–31 January 1943</span></p>
<p class="noindent"><span href="#/xhtml/11_Chapter02_2#fig2_4" title="Link target outside of Sample">Advance of Hoth’s Panzerarmee 4 on first day of <i>Zitadelle</i>, 5 July 1943</span></p>
<p class="noindent"><span href="#/xhtml/11_Chapter02_2#fig2_5" title="Link target outside of Sample">Operation <i>Rumyantsev</i>, the breakthrough of 1st Tank Army and 5th Guards Tank Army, 8 August 1943</span></p>
<p class="noindent"><span href="#/xhtml/11_Chapter02_2#fig2_6" title="Link target outside of Sample">Battle of Bogodukhov, 13–16 August 1943, <i>Totenkopf</i> vs. the 1st Tank Army</span></p>
<p class="noindent"><span href="#/xhtml/11_Chapter02_2#fig2_7" title="Link target outside of Sample">Soviet breakout from the Lyutezh Bridgehead and liberation of Kiev, 3–5 November 1943</span></p>
<p class="noindent"><span href="#/xhtml/13_Chapter03#fig3_1" title="Link target outside of Sample">German Effort to relieve the Korsun Pocket, 1–16 February 1944</span></p>
<p class="noindent"><span href="#/xhtml/13_Chapter03#fig3_2" title="Link target outside of Sample">Second Battle of Tirgu Fromos, 2 May 1944</span></p>
<p class="noindent"><span href="#/xhtml/13_Chapter03#fig3_3" title="Link target outside of Sample">Advance of Soviet tank armies during Operation Bagration and Lvov-Sandomierz Offensive, June–July 1944</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Maps.vue?405c4ba8